// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__radioGroup--KXruE {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__twoColumns--R3AYS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__boolBox--D1TFv {
  display: inline-flex;
  gap: 16px;
  cursor: pointer;
}
.src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__footer--NEzMH {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Settings/Planning2Settings.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAAF;AAGA;EACE,oBAAA;EACA,SAAA;EACA,eAAA;AADF;AAIA;EACE,YAAA;AAFF","sourcesContent":[".radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.twoColumns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.boolBox {\n  display: inline-flex;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.footer {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": `src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__radioGroup--KXruE`,
	"twoColumns": `src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__twoColumns--R3AYS`,
	"boolBox": `src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__boolBox--D1TFv`,
	"footer": `src-businessServices-services-bsPlanning2-Planning2Settings-Planning2Settings-module__footer--NEzMH`
};
export default ___CSS_LOADER_EXPORT___;
